module.exports = __webpack_public_path__ + "static/media/baatutsetting.bdb6a599.jpg";